"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var hs_web_style_guide_1 = require("@headspace/hs-web-style-guide");

var colors_1 = require("@headspace/hs-web-style-guide/dist/colors");

var TOAST_HEIGHT = 28;
var TOAST_BOTTOM_MARGIN = 14;
exports.tableStyle = hs_web_style_guide_1.css({
  display: 'flex',
  flexDirection: 'column',
  flex: '1 1 auto',
  width: '100%'
});
exports.headerRowStyle = hs_web_style_guide_1.css({
  display: 'flex',
  flexDirection: 'row',
  padding: '26px 40px',
  alignItems: 'center',
  ' .cell': {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    fontSize: 12,
    color: colors_1.silverChalice,
    textTransform: 'uppercase',
    letterSpacing: 2.5,
    fontWeight: 700,
    borderRight: "1px solid " + colors_1.carrarra,
    height: 24,
    cursor: 'pointer',
    ':hover .cellSort': {
      display: 'block'
    },
    ':last-of-type': {
      borderRight: 'none',
      marginRight: 0,
      ' svg': {
        marginRight: 0
      }
    }
  },
  outline: 'none',
  userSelect: 'none'
});
exports.rowStyle = hs_web_style_guide_1.css({
  display: 'flex',
  flexFlow: 'row',
  alignItems: 'center',
  backgroundColor: colors_1.white,
  borderRadius: 4,
  border: "1px solid " + colors_1.carrarra,
  boxShadow: '0 2px 0 0 rgba(0,0,0,0.04)',
  padding: '23px 40px',
  marginBottom: 8,
  ':last-of-type': {
    marginBottom: 0
  },
  outline: 'none',
  ' .cell:last-of-type': {
    marginRight: 0
  },
  ' .cell > *:not(.dropdown), .cell > *:not(.dropdown) *': {
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    wordBreak: 'break-word',
    userSelect: 'none',
    overflow: 'hidden'
  }
});
var vistaBlueOpacity10 = colors_1.rgba(colors_1.vistaBlue, 0.1);
exports.selectRowStyle = hs_web_style_guide_1.css(exports.rowStyle, {
  borderColor: colors_1.vistaBlue,
  background: "linear-gradient(" + vistaBlueOpacity10 + ", " + vistaBlueOpacity10 + "), linear-gradient(" + colors_1.white + ", " + colors_1.white + ")"
});
exports.cellStyle = hs_web_style_guide_1.css({
  display: 'flex',
  flexDirection: 'row',
  flexGrow: 1,
  flexBasis: 0,
  justifyContent: 'space-between',
  alignItems: 'center',
  minWidth: 0,
  fontSize: 14,
  color: colors_1.tundora,
  marginRight: 16,
  outline: 'none',
  ' *': {
    width: 'inherit'
  }
});
exports.selectRowCellStyle = hs_web_style_guide_1.css(exports.cellStyle, {
  flexGrow: 0,
  flexBasis: 16,
  marginRight: 32,
  width: 16
});
exports.cellSortStyle = hs_web_style_guide_1.css({
  display: 'none'
});
exports.activeSortCellStyle = hs_web_style_guide_1.css({
  '.cell': {
    color: colors_1.tundora
  },
  '> .cellSort': {
    display: 'block',
    '> .sortStyle svg': {
      fill: colors_1.tundora
    }
  }
});
exports.sortStyle = hs_web_style_guide_1.css({
  '> svg': {
    width: 14,
    height: 14,
    marginRight: 16,
    fill: colors_1.silverChalice
  }
});
exports.actionsStyle = hs_web_style_guide_1.css({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'flex-end',
  '& button, & .dropdown': {
    marginLeft: 16
  }
});
exports.searchStyle = hs_web_style_guide_1.css({
  display: 'flex',
  flexDirection: 'row',
  flexGrow: 1,
  alignItems: 'center',
  height: 20,
  backgroundColor: colors_1.pampas,
  borderRadius: 4,
  padding: 12
});
exports.clearSearchStyle = hs_web_style_guide_1.css({
  outline: 'none'
});
exports.searchInputStyle = hs_web_style_guide_1.css({
  marginLeft: 16,
  border: 'none',
  fontSize: 16,
  flexGrow: 1,
  outline: 'none',
  background: 'transparent',
  ':focus': {
    '::-webkit-input-placeholder': {
      color: 'transparent'
    },
    '::-moz-placeholder': {
      color: 'transparent'
    },
    '::-ms-input-placeholder': {
      color: 'transparent'
    },
    '::-ms-clear': {
      display: 'none'
    }
  }
});
exports.noResultsFoundStyle = hs_web_style_guide_1.css({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: colors_1.comet,
  flexGrow: 1,
  fontSize: 20
});
exports.toastWrapperStyle = hs_web_style_guide_1.css({
  position: 'fixed',
  left: 0,
  bottom: 22,
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  height: 0
});
exports.toastStyle = hs_web_style_guide_1.css({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  backgroundColor: colors_1.comet,
  color: colors_1.white,
  borderRadius: 4,
  padding: '8px 16px',
  fontSize: 16,
  width: '50%',
  height: TOAST_HEIGHT,
  transform: "translateY(-" + (TOAST_HEIGHT + TOAST_BOTTOM_MARGIN) + "px)"
});
exports.toastGroupStyle = hs_web_style_guide_1.css({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center'
});
exports.closeToastStyle = hs_web_style_guide_1.css({
  width: 16,
  height: 16,
  marginRight: 16,
  cursor: 'pointer'
});
exports.rowsCountStyle = hs_web_style_guide_1.css({
  backgroundColor: colors_1.white,
  borderRadius: 2,
  width: 32,
  height: 32,
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  color: colors_1.comet,
  marginRight: 8
});
exports.unselectRowsStyle = hs_web_style_guide_1.css({
  fontSize: 12,
  textTransform: 'uppercase',
  letterSpacing: 2.5,
  cursor: 'pointer'
});
exports.clickableStyle = hs_web_style_guide_1.css({
  cursor: 'pointer'
});
exports.noSelectRowClickableStyle = hs_web_style_guide_1.css({
  ':hover .cell:nth-of-type(1)': {
    color: colors_1.jaffa,
    ' div': {
      color: 'inherit'
    }
  }
});
exports.hasSelectRowClickableStyle = hs_web_style_guide_1.css({
  ':hover .cell:nth-of-type(2)': {
    color: colors_1.jaffa,
    ' div': {
      color: 'inherit'
    }
  }
});